import app from 'flarum/forum/app';

/**
 * The settings the front end needs.
 *
 * Flarum 2.0's CorePayload does not carry the settings, so the front end
 * cannot read them out of `app.data`. They come from a small read-only
 * endpoint instead — see TopicSettingsResource.
 */

export const TOPIC_SETTINGS_DEFAULTS = {
  maxPerPost: 5,
  hotLimit: 6,
  hotShowHome: true,
  hotShowSidebar: true,
  hotShowMobileBar: false,
  allowedGroups: [],
  hotCurated: []
};
let loaded = null;
let pending = null;

/**
 * Fetch the settings once and keep them.
 *
 * The values are the same for everybody, and they change only when an admin
 * changes them, so one request per page load is plenty. A failure is not
 * fatal: the defaults are what the extension ships with, and a forum whose
 * settings endpoint is missing should still show its topics.
 */
export function topicSettings() {
  if (loaded) return Promise.resolve(loaded);
  if (!pending) {
    /**
     * The forum model is not there yet while the app is booting: Flarum
     * assigns `app.forum` after the initializers have run. Reading the API
     * URL before that throws, so the defaults stand in until the app is up.
     */
    const forum = app.forum;
    if (!forum) {
      return Promise.resolve({
        ...TOPIC_SETTINGS_DEFAULTS
      });
    }
    const url = `${forum.attribute('apiUrl')}/topic-settings`;
    pending = app.request({
      method: 'GET',
      url
    }).then(payload => {
      loaded = {
        ...TOPIC_SETTINGS_DEFAULTS,
        ...(payload?.data?.attributes ?? {})
      };

      // The rules and the switches are read from the settings as they are
      // known right now, so the page has to be drawn again once they are in.
      m.redraw();
      return loaded;
    }).catch(() => {
      loaded = {
        ...TOPIC_SETTINGS_DEFAULTS
      };
      m.redraw();
      return loaded;
    });
  }
  return pending;
}

/**
 * The settings as they are known right now.
 *
 * Before the request has come back this is the defaults, which is the right
 * answer often enough not to be worth blocking the first paint on.
 */
export function currentTopicSettings() {
  return loaded ?? TOPIC_SETTINGS_DEFAULTS;
}
flarum.reg.add('ziiven-topics', 'forum/state/topicSettings', { TOPIC_SETTINGS_DEFAULTS: TOPIC_SETTINGS_DEFAULTS,topicSettings: topicSettings,currentTopicSettings: currentTopicSettings, });